'use strict';

const $ = jQuery.noConflict();
import sliders from '../../../src/js/shared/sliders';

$(function() {
	const retailersSlider = {
		init: function() {
			this.cacheDOM();
			this.bindEvents();
			this.initSlider();
		},
		cacheDOM: function() {
			this.$slider = $('.js-retailers-slider');
		},
		bindEvents: function() {
			this.$slider.on('mouseenter', this.pauseAutoplay.bind(this));
			this.$slider.on('mouseleave', this.resumeAutoplay.bind(this));
		},
		initSlider: function() {
			const count = this.$slider.find('.slider__item').length;

			if (count < 2) {
				$('.js-retailers-prev, .js-retailers-next').hide();
				return;
			}

			sliders.initializeSlider('.js-retailers-slider', {
				slidesToShow: 1,
				slidesToScroll: 1,
				autoplay: true,
				autoplaySpeed: 2000,
				speed: 700,
				arrows: true,
				prevArrow: '.js-retailers-prev',
				nextArrow: '.js-retailers-next',
				infinite: true,
				rows: 0,
				pauseOnHover: true,
				swipe: true,
				touchThreshold: 10,
				cssEase: 'ease-in-out',
				waitForAnimate: true,
				centerMode: true,
				responsive: [
					{
						breakpoint: 767,
						settings: {
							slidesToShow: 1,
						}
					},
				],
			});
		},
		pauseAutoplay: function() {
			this.$slider.slick('slickPause');
		},
		resumeAutoplay: function() {
			this.$slider.slick('slickPlay');
		},
	};

	retailersSlider.init();
});
